import type { FaireProductEntity } from "../../entity_types/product";

export const p_9bqgaj98fb: FaireProductEntity = {
  token: "p_9bqgaj98fb",
  type: "product",
  name: "Sovereign Silver - First Aid Gel - 1 Each-1 Oz",
  brandToken: "b_7xgwjjb7p6",
  brandName: "Everyday Supply Co",
  imageUrl:
    "https://cdn.faire.com/fastly/38c972699f5921bfaad308822c0c8ce960304f6e15b85ddd074f9e24ffe9d4fc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/043df21d717d1fd1921a74bfacc2a25b573ca6d20280391d015e80eba72e6b15.jpeg",
  ],
  priceDollars: 22.49,
  description:
    "\n\nThis compact first aid gel is your go-to solution for minor skin troubles. Formulated with silver hydrosol and argentum metallicum, it offers a natural, homeopathic approach to soothing inflammation and promoting skin healing. Perfectly sized for travel, this gel contains no synthetic preservatives, ensuring a gentle touch on your skin.\n\n * Free from gluten, GMOs, wheat, and yeast, making it ideal for sensitive users. \n * Completely vegan and crafted in the USA, specifically in Florida. \n * Designed for easy application and quick absorption. \nWhether you're dealing with cuts, bruises, or burns, this versatile 1 oz gel provides effective relief and care.\n",
  tags: [],
  msrpDollars: 44.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:57.814Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
